module.exports = __webpack_public_path__ + "static/media/weather-1.495fb1e3.svg";